import React from 'react';
import { motion } from 'framer-motion';
import '../csscomponent/LegalPages.css';

const policyItems = [
  {
    title: '1. Information We Collect',
    text: 'We collect information you submit directly (such as name, email address, phone number, and project inquiries), account details, and automatic technical diagnostics (device model, OS version, IP address, and app crash logs).',
  },
  {
    title: '2. Third-Party Services & SDKs',
    text: 'Our Android application and website integrate Google Firebase (authentication, real-time database, analytics) and Google AdMob (for serving relevant advertisements and analytics). These services may process identifiers under their respective privacy policies.',
  },
  {
    title: '3. How We Use Data',
    text: 'Collected data is used to authenticate users, fulfill requested services, provide customer support, display contextual advertisements, and ensure the security and performance of our app.',
  },
  {
    title: '4. Data Sharing & Security',
    text: 'We do not sell personal data. We implement industry-standard encryption (HTTPS/TLS) and secure database access rules to protect your data against unauthorized access or loss.',
  },
  {
    title: '5. Account & Data Deletion',
    text: 'You have full rights to request deletion of your account and personal data at any time. Simply email us at info@servicesanddeveloper.in with the subject "Data Deletion Request".',
  },
  {
    title: '6. Children’s Privacy',
    text: 'Our services are not intended for children under 13 years of age, and we do not knowingly collect personal information from children.',
  },
];

function PrivacyPolicy() {
  return (
    <section className="legal-page">
      <motion.div
        className="legal-hero"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55 }}
      >
        <p>Privacy Policy</p>
        <h1>How we collect, use, and protect your data</h1>
        <span>
          This policy applies to interactions on the Services and Developer website, including service inquiries,
          account pages, and brochure/product-related requests.
        </span>
      </motion.div>

      <div className="legal-grid">
        {policyItems.map((item, index) => (
          <motion.article
            key={item.title}
            className="legal-card"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.08 }}
          >
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </motion.article>
        ))}
      </div>

      <p className="legal-note">Last updated: February 23, 2026</p>
    </section>
  );
}

export default PrivacyPolicy;
